export default "__VITE_ASSET__0vrmTLpV__"